export default __webpack_public_path__ + "static/bg-finance-04666973910f1f3f198d2c52d878362b.jpg";